/**
 * Sidebar entries for vessel portal routes (`/dashboard`, `/requisitions`, …).
 * Add a row here when you add a new folder under `src/vessel-modules/`.
 */
export type VesselSidebarModuleDef = {
  /** URL path segment from root, e.g. `requisitions` → `/requisitions` */
  pathSegment: string;
  /** Label for the list route */
  listLabel: string;
  permissionModuleKey: string;
  /** Sidebar group this entry belongs to */
  group: 'supplies' | 'spares' | 'crew';
  /** Optional quick link (e.g. create form) */
  newLink?: { label: string; pathSuffix: string };
};

export const VESSEL_SIDEBAR_MODULES: VesselSidebarModuleDef[] = [
  {
    pathSegment: 'dashboard',
    listLabel: 'Dashboard',
    permissionModuleKey: 'vessel_dashboard',
    group: 'supplies',
  },
  {
    pathSegment: 'requisitions',
    listLabel: 'Supply Requisition',
    permissionModuleKey: 'vessel_supply_requisitions',
    group: 'supplies',
    newLink: { label: 'New requisition', pathSuffix: '/new' },
  },
  {
    pathSegment: 'pending-deliveries',
    listLabel: 'Pending deliveries',
    permissionModuleKey: 'vessel_pending_deliveries',
    group: 'supplies',
  },
  {
    pathSegment: 'spare-requisitions',
    listLabel: 'Spare Requisition',
    permissionModuleKey: 'vessel_spare_requisitions',
    group: 'spares',
    newLink: { label: 'New spare requisition', pathSuffix: '/new' },
  },
  {
    pathSegment: 'spare-pending-deliveries',
    listLabel: 'Pending deliveries',
    permissionModuleKey: 'vessel_spare_pending_deliveries',
    group: 'spares',
  },
  {
    pathSegment: 'crew',
    listLabel: 'Crew list',
    permissionModuleKey: 'vessel_crew',
    group: 'crew',
  },
  {
    pathSegment: 'wrh',
    listLabel: 'Working Rest Hours',
    permissionModuleKey: 'vessel_wrh',
    group: 'crew',
  },
  {
    pathSegment: 'mga',
    listLabel: 'MGA',
    permissionModuleKey: 'vessel_mga',
    group: 'crew',
    newLink: { label: 'New period', pathSuffix: '/new' },
  },
];
